<app-footer-label  class='d-none d-md-block' >  </app-footer-label> 
<app-footer-link [menuType] = "'fixedFooter'" [site]=site > </app-footer-link>

<ng-container class="d-block d-md-none">
    <app-footer-label  class="d-block d-md-none">  </app-footer-label> 
    <span class="my-1 d-block d-md-none"><br> </span>
</ng-container>
    